import { TranslationObject } from '../i18n/translation';

const translations: TranslationObject = {
  title: {
    id: 'unknown.user.title',
    nb: 'Arbeidslivsportalen',
    en: 'Arbeidslivsportalen',
  },
  description: {
    id: 'unknown.user.description',
    nb: 'Du har ingen brukerrolle!',
    en: 'You have no granted user role',
  },
  more: {
    id: 'unknown.user.more',
    nb: 'Du er har ingen tildelte brukerroller i Arbeidslivsportalen. Dersom du mener dette er feil, ta kontakt med administrasjonen ved ditt studie- eller praksissted.',
    en: 'You do not have any user roles granted in Arbeidslivsportalen. If you think this is an error, please contact the administration at your study or practice place.',
  },
  backbutton: {
    id: 'unknown.user.backbutton',
    nb: 'Tilbake til login',
    en: 'Back to login',
  },
};

export default translations;
